export default __webpack_public_path__ + "static/media/paikangforest.6cdf6fbd.jpg";